import React from "react";
var __jsx = React.createElement;
var OilBanner = function OilBanner(_ref) {
  var section = _ref.section;
  var content = section.content;
  var inner = /*#__PURE__*/React.createElement("div", {
    className: "relative w-full overflow-hidden rounded-lg md:rounded-none"
  }, /*#__PURE__*/React.createElement("img", {
    src: content.image_mobile,
    alt: "",
    loading: "eager",
    className: "block md:hidden w-full h-[116px] object-cover"
  }), /*#__PURE__*/React.createElement("img", {
    loading: "eager",
    src: content.image,
    alt: "syarah oil banner",
    className: "hidden md:block h-[180px] w-full"
  }), /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 flex flex-col justify-center items-start text-start gap-1 ps-4 pe-2 md:ps-16 md:pe-0 md:gap-4 w-[58%] md:w-full"
  }, content.title && /*#__PURE__*/React.createElement("h1", {
    className: "text-white font-extrabold text-[18px] leading-[28px] tracking-[-0.45px] md:text-4xl md:leading-snug md:tracking-normal m-0"
  }, content.title), content.subtitle && /*#__PURE__*/React.createElement("p", {
    className: "max-w-60 md:max-w-full text-white font-normal text-[12px] leading-[16px] tracking-[-0.3px] md:text-[20px] md:leading-relaxed md:tracking-normal m-0"
  }, content.subtitle)));
  return /*#__PURE__*/React.createElement("div", {
    className: "block max-w-[1200px] mx-auto px-4 mb-6 md:px-0 md:mb-8 md:mt-4"
  }, inner);
};
export default OilBanner;